module.exports = __webpack_public_path__ + "img/telephone.14555524.svg";